export const DEFAULT_MAP_STYLE =
  'mapbox://styles/bryanhc/cl7ieb06h001m15kdnry1u0i1';
